<script>
import Swal from "sweetalert2";
import AutoProctorService from "@/helpers/AutoProctorService.js";

export default {
  props: {
    nama_kompetensi: String,
    level: String,
    nip_peserta: String,
    proctoringConfiguration: Object,
  },

  emits: ["stopPreview", "deactiveStatus"],

  data() {
    return {
      cameraEnabled: false,
      screenEnabled: false,
    };
  },

  async mounted() {
    // await this.$nextTick();

    // let cameraAttached = false;
    // let screenAttached = false;

    // await AutoProctorService.checkScreenShare(false);


    // const tryAttach = async () => {
    //   if (AutoProctorService.cameraStream && !cameraAttached) {
    //     await AutoProctorService.attachCameraPreview(this.$refs.cameraPreview);

    //     cameraAttached = true;
    //   }


    //   if (AutoProctorService.screenStream && !screenAttached) {
    //     await AutoProctorService.attachScreenPreview(this.$refs.screenPreview);

    //     screenAttached = true;
    //   }
    //   if (!cameraAttached || !screenAttached) {
    //     setTimeout(tryAttach, 200);
    //   }
    // };

    // tryAttach();
  },

  methods: {
    refreshPage() {
      window.location.reload();
    },

    async toggleCamera() {
      if (this.cameraEnabled) {
        // Checkbox true → nyalakan kamera
        const result = await AutoProctorService.checkPermissions();

        if (result.success) {
          await this.$nextTick();

          await AutoProctorService.attachCameraPreview(
            this.$refs.cameraPreview
          );
        } else {          
          this.$emit('deactiveStatus');
          this.cameraEnabled = false;
        }
      } else {
        // Checkbox false → matikan kamera
        AutoProctorService.stopCamera();

        if (this.$refs.cameraPreview) {
          this.$refs.cameraPreview.srcObject = null;
        }
      }
    },

    async toggleScreenPreview() {
      if (this.screenEnabled) {
        // Checkbox true → nyalakan screen preview
        const result = await AutoProctorService.checkScreenShare();

        if (result.success) {
          await this.$nextTick();

          await AutoProctorService.attachScreenPreview(
            this.$refs.screenPreview
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Gagal mengakses screen share",
            text: result.message,
          });
          this.screenEnabled = false;
        }
      } else {
        // Checkbox false → matikan screen preview
        AutoProctorService.stopScreenShare();

        if (this.$refs.screenPreview) {
          this.$refs.screenPreview.srcObject = null;
        }
      }
    }
  }
};
</script>

<template>
  <div class="full-page-watermark">
    {{ nip_peserta }}
  </div>
  <div class="mym-quizz-header" ref="quizHeader">
    <div class="mym-quizz-navbar">
      <div class="mym-information">
        <h4 class="title-navbar-information">ASESMEN HARD COMPETENCY</h4>
        <span class="sub-title-navbar-information me-2">
          {{ nama_kompetensi }}
        </span>
        <span class="mym-badge mym-soft-badge-primary">Level {{ level }}</span>
      </div>
    </div>
  </div>

  <div class="mym-quizz-body p-4">
    <div class="mym-question-cardbox" v-if="proctoringConfiguration.loading">
      <div class="d-flex w-100 justify-content-center">
        <h3>
          <i class="fa fa-spin fa-spinner me-1 text-primary"></i> Proses cek
          akses
        </h3>
      </div>
    </div>

    <div
      v-else-if="proctoringConfiguration.preview"
      class="mym-question-cardbox"
    >
      <div class="d-flex mb-5">
        <div class="w-50 d-flex flex-column align-items-center">
          <h4>
            <b-form-checkbox v-model="cameraEnabled" name="check-button" switch @change="toggleCamera">
              Tes Preview Kamera
            </b-form-checkbox>
          </h4>
          <div class="camera-box mb-3">
            <video
              ref="cameraPreview"
              autoplay
              muted
              playsinline
              class="camera-video"
            ></video>
          </div>

          <div class="w-75">
            <b-alert show variant="info">
              <h4 class="alert-heading">
                <i class="fa fa-info-circle me-1"></i> Catatan
              </h4>

              <hr/>

              <ol class="mym-list list-red mb-0 ps-0">
                <li>
                  Pastikan berada diruangan yang cukup pencahayaan saat mengakses kamera.
                </li>
                <li>
                  Pastikan tidak mengalihkan pandangan dari layar selama proses asesmen berlangsung.
                </li>
                <li class="mb-0">
                  Pastikan tidak meninggalkan area dari kamera selama proses asesmen berlangsung.
                </li>
              </ol>
            </b-alert>
            
          </div>
        </div>

        <div class="w-50 d-flex flex-column align-items-center">
          <button
            class="mym-btn mym-bg-success fw-bold w-100"
            @click="$emit('stopPreview')"
          >
            <i class="fas fa-play me-1"></i>
            Mulai Asesmen
          </button>
          <!-- <h4>
            <b-form-checkbox v-model="screenEnabled" name="check-button" switch @change="toggleScreenPreview">
              Tes Preview Layar
            </b-form-checkbox>
          </h4>
          <div class="screen-box mb-3">
            <video
              ref="screenPreview"
              autoplay
              muted
              playsinline
              class="screen-video"
            ></video>
          </div>

          <div class="w-75">
            <b-alert show variant="info">
              <h4 class="alert-heading">
                <i class="fa fa-info-circle me-1"></i> Catatan
              </h4>

              <hr/>

              <ol class="mym-list list-red mb-0 ps-0">
                <li>
                  Pastikan membagikan seluruh layar (Entire Screen) saat mengakses screen share.
                </li>
              </ol>
            </b-alert>
            
          </div> -->
        </div>
      </div>

      <!-- <div class="d-flex justify-content-center align-items-center flex-column">
        <button
          class="mym-btn mym-bg-success fw-bold"
          @click="$emit('stopPreview')"
        >
          <i class="fas fa-play me-1"></i>
          Mulai Asesmen
        </button>
      </div> -->
    </div>

    <div v-else class="mym-question-cardbox" style="justify-items: center;">
      <div class="d-flex w-50 justify-content-center mb-5">
        <img
          src="@/assets/images/proctor/permissions-instruction.png"
          class="d-block"
          style="width: 100%"
        />
      </div>

      <div class="d-flex w-50">
        <div class="row">
          <div class="col-12 mb-3">
            <ol class="mym-list list-red mb-5">
              <li>
                Pastikan akses kamera diizinkan.
              </li>
              <li>
                Pastikan akses mikrofon diizinkan.
              </li>
              <li>
                Pastikan saat memilih opsi akses layar, pilih opsi seluruh layar.
              </li>
            </ol>
          </div>
  
          <div class="col-12 text-center">
            <p class="mb-3">
              Setelah mengikuti instruksi diatas, dan sudah memberikan izin akses
              ke Michrophonem dan Kamera, silahkan klik tombol
              <i class="fw-bold">'Refresh Halaman'</i>.
            </p>
  
            <button class="mym-btn mym-bg-primary" @click="refreshPage()">
              <i class="fa fa-sync me-1"></i>
              Refresh Halaman
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>